// extracted by mini-css-extract-plugin
module.exports = {"vibeProductCard":"VibeSection_vibeProductCard__l50nO","compactVibeTabs":"VibeSection_compactVibeTabs__Pkz_p"};